import { api } from "@/api";

export const deleteMonitorError = async (
  fingerprint: string
): Promise<void> => {
  await api.client.delete(`/monitor/errors/${fingerprint}`);
};
